package com.bikompanion.domain.usecase

import dev.zacsweers.metro.Inject
import com.bikompanion.domain.StationWatchRepository
import com.bikompanion.domain.StationWatchUpdate
import com.bikompanion.domain.analytics.AnalyticsTracker
import com.bikompanion.domain.analytics.DomainAnalyticsEvents

@Inject
class ExpireStationWatchesUseCase(
    private val repository: StationWatchRepository,
    private val analytics: AnalyticsTracker,
) {
    operator fun invoke(nowEpochMillis: Long): StationWatchUpdate {
        val expired = repository.removeExpired(nowEpochMillis)
        expired.forEach { analytics.track(DomainAnalyticsEvents.stationWatchExpired(it)) }
        return StationWatchUpdate(
            activeWatches = repository.watches(),
            expiredWatches = expired,
        )
    }
}
